export const columnWidths = {
  offset: 8,
  icon: 50,
  common: 200,
  small: 100,
};
